<app-page-container [title]="tableName">
  <app-messaging-header [tableKey]="tableKey"
                        [folderService]="messageFolderService"
                        [isFolderEmpty]="!data?.length"
                        (folderChanged)="folderSelected($event)">
  </app-messaging-header>

  <app-table [tableKey]="tableKey"
             [displayedColumns]="displayedColumns"
             [data]="data"
             [length]="length"
             [dataType]="dataType"
             (tableData)="getReports($event)"
             (actionEmit)="actionHandler($event)">
  </app-table>
</app-page-container>
